export const isString = str => typeof str === "string" || str instanceof String;

export const isStringFilled = str => isString(str) && str.length > 0;
